export default {
  title: {
    type: String,
    default: '差异数量公式设置',
  },
  sideModalWidth: {
    type: [String, Number],
    default: 568,
  },
  variableLabel: {
    type: String,
    default: '变量',
  },
  operatorLabel: {
    type: String,
    default: '运算符',
  },
  labelPadding: {
    type: String,
    default: '10px 0',
  },
  resetBtn: {
    type: String,
    default: '重置',
  },
  saveBtn: {
    type: String,
    default: '保存',
  },
  saveAndOtherBtn: {
    type: String,
    default: '保存并刷新',
  },
  operatorOptions: {
    type: Array,
    default: () => [
      {
        type: 2,
        code: '+',
        name: '+',
      },
      {
        type: 2,
        code: '-',
        name: '-',
      },
    ],
  },
  getOptionsReqMethod: {
    type: String,
    default: 'get',
  },
  getOptionsReqParams: {
    type: Object,
    default: () => {},
  },
  alertMsg: {
    type: String,
    default: '保存失败，公式格式错误',
  },
  getOptionsUrl: {
    type: String,
    default: '',
  },
  saveReqMethod: {
    type: String,
    default: 'post',
  },
  saveReqUrl: {
    type: String,
    default: '',
  },
  saveReqParams: {
    type: Object,
    default: () => {},
  },
  saveAndOtherReqMethod: {
    type: String,
    default: 'post',
  },
  saveAndOtherReqParams: {
    type: Object,
    default: () => {},
  },
  saveAndOtherReqUrl: {
    type: String,
    default: '',
  },
  paramsKey: {
    type: String,
    default: 'notations',
  },
  objParamsKey: {
    type: String,
    default: 'variate',
  },
  optionNameKey: {
    type: String,
    default: 'name',
  },
  getResetReqMethod: {
    type: String,
    default: 'get',
  },
  getResetReqParams: {
    type: Object,
    default: () => {},
  },
  getResetUrl: {
    type: String,
    default: '',
  },
  getDefaultReqMethod: {
    type: String,
    default: 'post',
  },
  getDefaultReqParams: {
    type: Object,
    default: () => {},
  },
  getDefaultReqUrl: {
    type: String,
    default: '/rest/main/misc/formula/getCalculator',
  },
  saveAndOtherBtnShow: {
    type: Boolean,
    default: true,
  },
  onSide: {
    type: Boolean,
    default: false,
  },
}
